import React from 'react'

const NotFoundMeals = () => {
    return (
        <div className='h-[calc(100vh-404px)] flex justify-center items-center text-white capitalize text-5xl font-bold'>
            <h1>not found meal</h1>
        </div>
    )
}

export default NotFoundMeals